import isTypedArray from "./is-typed-array";

export default function isNDArrayLike(obj) {
  return (
    !!obj &&
    typeof obj === "object" &&
    Array.isArray(obj.shape) &&
    Array.isArray(obj.stride) &&
    typeof obj.offset === "number" &&
    obj.shape.length === obj.stride.length &&
    (Array.isArray(obj.data) || isTypedArray(obj.data))
  );
}
